export function deriveSessionsFromPageViews(pageViews) {
  if (!pageViews || pageViews.length === 0) return [];

  const sessionMap = new Map();

  for (const pv of pageViews) {
    const id = pv.sessionId || "__unknown__";
    if (!sessionMap.has(id)) {
      sessionMap.set(id, {
        sessionId: id,
        start: pv.timestamp,
        end: pv.timestamp,
        pageViews: [],
        browser: pv.browser,
        os: pv.os,
        deviceType: pv.deviceType,
        city: pv.city,
        country: pv.country,
      });
    }
    const session = sessionMap.get(id);
    if (new Date(pv.timestamp) < new Date(session.start)) session.start = pv.timestamp;
    if (new Date(pv.timestamp) > new Date(session.end))   session.end   = pv.timestamp;
    session.pageViews.push(pv);
  }

  return Array.from(sessionMap.values()).sort(
    (a, b) => new Date(b.start) - new Date(a.start)
  );
}
